/* eslint-disable class-methods-use-this */

export class SearchResultItem {
  getId() {
    return '';
  }

  getName() {
    return '';
  }

  getTextSnippets() {
    return [];
  }

  // eslint-disable-next-line no-unused-vars
  getTableProjection(metadata = {}) {
    throw new Error('Not implemented interface!');
  }

  getProperty() {
    throw new Error('Not implemented interface!');
  }

  getProjectProperty() {
    throw new Error('Not implemented interface!');
  }
}
/* eslint-enable class-methods-use-this */

export default {SearchResultItem};
